import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ComponentizedEquipment} from '../shared/componentized-equipment.model';
import {MatDialog} from '@angular/material/dialog';
import {EquipmentComponentizationFormDialogComponent} from '../equipment-componentization-form-dialog/equipment-componentization-form-dialog.component';

@Component({
  selector: 'lib-item-summary-equipment-componentization-action',
  templateUrl: './equipment-componentization-action.component.html'
})
export class EquipmentComponentizationActionComponent implements OnInit, OnChanges {

  @Input() selectedItems: ComponentizedEquipment[] = [];
  @Output() refresh = new EventEmitter<boolean>();
  hint: string;
  shouldBeDisabled: boolean;

  constructor(private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.handleSelectedItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedItems
          && !changes.selectedItems.isFirstChange()
          && changes.selectedItems.currentValue) {
      this.handleSelectedItems();
    }
  }

  private handleSelectedItems(): void {
    if (this.selectedItems.length === 0) {
      this.hint = 'No assets selected.';
      this.shouldBeDisabled = true;
      return;
    }

    if (this.selectedItems.length === 1) {
      this.hint = 'At least 2 assets of the same owner code are required.';
      this.shouldBeDisabled = true;
      return;
    }

    const ownerCode = this.selectedItems[0].ownerCode;
    const saleGroupId = this.selectedItems[0].saleGroupId;
    let hasMoreThanOneOwnerCode = false;
    let hasMoreThanOneSaleGroupId = false;
    let oneOfEquipmentPartOfComponentization = false;
    let oneOfEquipmentSoldOrCollapsed = false;
    const AUCTION_STATUS_SOLD = 3;
    const ITEM_CANCELLED_STATUS = 9;
    let oneOfEquipmentCancelled = false;
    let oneOfEquipmentMoved = false;

    this.selectedItems.forEach(selectedItem => {
      if (selectedItem.ownerCode !== ownerCode) {
        hasMoreThanOneOwnerCode = true;
      }

      if (selectedItem.saleGroupId !== saleGroupId) {
        hasMoreThanOneSaleGroupId = true;
      }

      if (selectedItem.parentComponent || selectedItem.childComponent) {
        oneOfEquipmentPartOfComponentization = true;
      }

      if (selectedItem.auctionStatusId === AUCTION_STATUS_SOLD) {
        oneOfEquipmentSoldOrCollapsed = true;
      }

      if (selectedItem.equipStatusId === ITEM_CANCELLED_STATUS) {
        oneOfEquipmentCancelled = true;
      }

      if (selectedItem.deleted) {
        // deleted means either cancelled (already taken care above) or moved
        // that's when once it got here, it's a moved item
        oneOfEquipmentMoved = true;
      }
    });

    if (hasMoreThanOneOwnerCode) {
      this.shouldBeDisabled = true;
      this.hint = 'Only assets having the same owner code can be componentized.';
      return;
    }

    if (hasMoreThanOneSaleGroupId) {
      this.shouldBeDisabled = true;
      this.hint = 'The selected assets do not belong to the same sale group / ring..';
      return;
    }

    if (oneOfEquipmentPartOfComponentization) {
      this.shouldBeDisabled = true;
      this.hint = 'One of the selected items is part of an existing componentization. Please decomponentize it before continuing.';
      return;
    }

    if (oneOfEquipmentSoldOrCollapsed) {
      this.shouldBeDisabled = true;
      this.hint = 'One of the selected items is Sold or Collapsed.';
      return;
    }

    if (oneOfEquipmentCancelled) {
      this.shouldBeDisabled = true;
      this.hint = 'One of the selected items is Cancelled.';
      return;
    }

    if (oneOfEquipmentMoved) {
      this.shouldBeDisabled = true;
      this.hint = 'One of the selected items has been moved to a different event.';
      return;
    }

    this.shouldBeDisabled = false;
    this.hint = '';
  }

  openComponentizationDialog() {
     const dialogRef = this.dialog.open(EquipmentComponentizationFormDialogComponent, {
       minWidth: '600px',
       maxWidth: '960px',
       disableClose: true,
       data: {
         equipment: this.selectedItems
       }
     });

     dialogRef.afterClosed()
       .subscribe(result => {
         if (result === 'Done') {
           this.refresh.emit(true);
         }
       });
  }
}
